<template>
	<div id="app">
		<el-container>
			<div class="inter">
				<el-row>
					<div class="header">
						<div class="flex_box">
							<div class="login">
								<a href=".">
									<img src="./assets/image/logo.png" />
								</a>
							</div>
							<div class="serch">
								<el-select v-model="value" class="one-search" placeholder="选择游戏" @change="gamechange">
									<el-option v-for="item in options" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
								<el-select v-model="value2" placeholder="游戏大区" @change="daquchange">
									<el-option v-for="item in options2" :key="item.value" :label="item.label"
										:value="item.value" :disabled="item.disabled">
									</el-option>
								</el-select>
								<el-select v-model="value3" placeholder="服务器">
									<el-option v-for="item in options3" :key="item.value" :label="item.label"
										:value="item.value" :disabled="item.disabled">
									</el-option>
								</el-select>
								<el-input class="serch-input" placeholder="请输入关键字" v-model="key">
								</el-input>
								<el-button type="primary" class="top-serchbtn" @click="serch" plain>搜索</el-button>
							</div>
						</div>
					</div>

				</el-row>
				<el-row>
					<div class="nav_top">
						<ul class="nav_list">
							<li v-for="(item, index) in navlist" v-if="index != 4">
								<router-link  :to="{ path: item.path }">
									<p>{{ item.name }}</p>
								</router-link>
							</li>

							<li>
								<router-link :to="{ path: 'user' }">
									<p>个人中心</p>
								</router-link>
							</li>
							<li>
								<router-link :to="{ path: 'zuhao' }">
									<p>租号专区</p>
								</router-link>
							</li>
							<li>
								<a href="http://api.h6ds.com/index/index/downpc" target="_blank">
									<p>APP下载</p>
								</a>

							</li>
						</ul>
					</div>
				</el-row>
			</div>
		</el-container>
		
		<!-- <router-view :key="this.$route.path"></router-view> -->
		<router-view ref="view" class="bg" />



		<div class="footer">
			<div class="inter">
				<div class="flex_box_bt">
					<div class="s1">
						<a href=".">
							<img src="./assets/image/logo.png" />
						</a>

						<div class="text">
							<p>版权所有@成都红六网络科技有限公司版权所有</p>
							<p><a href="https://beian.miit.gov.cn/" target="_blank"  style="color: #aaa;">蜀ICP备2022016706号-1 站长统计</a></p>
						
						</div>

					</div>
					<div class="s2">
						<a target="cyxyv"
							href="https://v.yunaq.com/certificate?domain=www.h6ds.com&amp;from=label&amp;code=90030">
							<img src="https://aqyzmedia.yunaq.com/labels/label_sm_90030.png"></a>
						<a target="cyxyv"
							href="https://si.trustutn.org/info?sn=386200922040122735834&amp;certType=1%22%3E%3Cimg%20src=">
							<img src="http://api.h6ds.com/index/image/foimg1.png"></a>
						<a target="cyxyv"
							href="https://si.trustutn.org/info?sn=386200922040122735834&amp;certType=1%22%3E%3Cimg%20src=">
							<img src="http://api.h6ds.com/index/image/foimg2.png"></a>
					</div>
				</div>

			</div>
		</div>

		<sell ref="sell" />


	</div>
</template>
<script>
	import sell from '@/components/dialogs/sell'
	export default {
		components: {
			sell
		},
		data() {
			return {
				sContent: "This is hello components",
				gamelist: [],
				options: [],
				options2: [{
					value: '0',
					label: '暂无数据',
					disabled: true,
				}],
				options3: [{
					value: '0',
					label: '暂无数据',
					disabled: true,
				}],
				value: 17,
				value2: '',
				value3: '',
				key: '',
				site: [],
				navlist: [{
						path: '/',
						name: '网站首页'
					},
					{
						path: 'gamelist',
						name: '账号交易'
					},
					{
						path: 'sell',
						name: '账号估价'
					},
					{
						path: 'business',
						name: '业务介绍'
					},
					{
						path: 'index',
						name: '玫瑰卡刀宏'
					},
					{
						path: 'about',
						name: '关于我们'
					},
				],
				topheader: 0,
				winWidth: 1920,
				winHeight: 0,
				

			}
		},
		computed: {
			isMobile() {
				return this.$store.getters.isMobile
			},
		},
		watch: {
			winWidth: {
				handler(v) {
					this.$store.commit('SET_IS_MOBILE', v <= 750 ? true : false)
					var route = this.$route
					if (v <= 1024) {
						if (route.name == 'goodsdetail') {
							location.href = "http://wap.h6ds.com/#/pages/game/index/detail?id=" + route.query.id
						} else if (route.name == 'goodsdetail2') {
							var str = route.params.id;
							var newStr = str.replace(/\.html$/, '');
							location.href = "http://wap.h6ds.com/#/pages/game/index/detail?id=" + newStr
						} else if (route.name == 'game') {
							
							if(route.query.keyword && route.query.keyword != ''){
								location.href = "http://wap.h6ds.com/#/pages/game/index/channel?id=" + route.query.gtype+"&q=" + route.query.keyword
							}else{
								location.href = "http://wap.h6ds.com/#/pages/game/index/channel?id=" + route.query.gtype
							}
						} else {
							location.href = "http://wap.h6ds.com"
						}
					}
				},
				immediate: true,
			},
		},
		created: function() {

			this.getChannelList('son', '19', 99);
			this.getSite();
			this.token()
			var that = this;
			setTimeout(function() {

				if (that.$route.query.topheader != undefined && that.$route.query.topheader != "") {
					that.$data.topheader = that.$route.query.topheader;
				}


				if (that.$route.query.gtype != undefined && that.$route.query.gtype != "") {

					that.$data.value = parseInt(that.$route.query.gtype);
					that.getDaqu(that.$data.value);
				}



				setTimeout(function() {
					if (that.$route.query.region != undefined && that.$route.query.region != "") {
						that.$data.value2 = parseInt(that.$route.query.region);
						that.getFuwuqi(that.$data.value2);
					}
				}, 100);
				setTimeout(function() {
					if (that.$route.query.server != undefined && that.$route.query.server != "") {
						that.$data.value3 = parseInt(that.$route.query.server);
					}
				}, 100);
				setTimeout(function() {
					if (that.$route.query.keyword != undefined && that.$route.query.keyword != "") {
						that.$data.key = that.$route.query.keyword;
					}
				}, 100);
			}, 500);

			this.getWinWidth()
			this.getWinHeight()

			window.onresize = () => {
				return (() => {
					this.getWinWidth()
					this.getWinHeight()

				})()
			}
		},
		methods: {

			openMai() {
				this.$refs['sell'].visible = true
			},
			getWinWidth() {
				window.width = document.body.clientWidth
				this.winWidth = window.width

			},
			getWinHeight() {
				window.height = document.body.clientHeight
				this.winHeight = window.height
			},
			getSite() {
				this.rq.requests.post("/api/Hall/getSite", {}).then(res => {
					this.$data.site = res.data;

				}).catch(error => {

				})
			},
			token() {
				var that = this
				this.rq.requests.post("api/Wxapp/Token", {
					token: localStorage.getItem('usertoken')
				}).then(res => {

					localStorage.setItem('usertoken', res.data.userinfo.token)
					that.$store.commit('SET_userinfo', res.data.userinfo)
				}).catch(error => {
					localStorage.removeItem('usertoken')
					sessionStorage.removeItem('usertoken')
				})
			},
			getChannelList(type, typeid, row) {
				this.rq.requests.post("/api/Hall/getChannelList", {
					type: type,
					typeid: typeid,
					row: row
				}).then(res => {
					this.$data.options = [];

					this.$store.commit('setList', res.data);
					for (let i = 0; i < res.data.length; i++) {
						var val = [];
						val.value = res.data[i].id;
						val.label = res.data[i].name;
						this.$data.options.push(val)
					}

				}).catch(error => {

				})

			},
			gamechange(id) {

				this.getDaqu(this.$data.value);
				this.$data.value2 = '';
				this.$data.value3 = '';
			},
			daquchange() {

				this.getFuwuqi(this.$data.value2);
				this.$data.value3 = '';
			},
			getDaqu(id) {
				this.rq.requests.post("/api/Hall/getDaqu", {
					id: id,

				}).then(res => {

					if (res.data.length >= 1) {
						this.$data.options2 = res.data;
					} else {
						this.$data.options2 = [];
						val.value = '0';
						val.label = '暂无数据';
						val.disabled = true;
						this.$data.options2.push(val)
					}
				}).catch(error => {

				})
			},
			getFuwuqi(id) {
				this.rq.requests.post("/api/Hall/getFuwqi", {
					id: id,

				}).then(res => {

					if (res.data.length >= 1) {
						this.$data.options3 = res.data;
					} else {
						this.$data.options3 = [];
						val.value = '0';
						val.label = '暂无数据';
						val.disabled = true;
						this.$data.options3.push(val)
					}
				}).catch(error => {

				})
			},
			serch() {



				if (this.$data.value != "") {
					this.$router.push({
						path: '/game?gtype=' + this.$data.value + '&region=' + this.$data.value2 + '&server=' +
							this.$data.value3 + "&keyword=" + this.$data.key
					})
				}

			}

		}
	}
</script>